import { render } from "./ThemeScheme.vue?vue&type=template&id=4c483f12"
import script from "./ThemeScheme.vue?vue&type=script&lang=js"
export * from "./ThemeScheme.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__